import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'


import { Link } from 'react-router-dom'
import Screen from '../../components/Screen'
import Table from '../../components/Table'
import useDashboard from '../../hooks/useDashboard'
import SummaryCard from './SummaryCard'


import { Card } from 'react-bootstrap'
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts"
import useAuth from '../../hooks/useAuth'

const Dashboard = () => {
  const { user } = useSelector(state => state.auth);
  const {isAdmin,isCompany} = useAuth()
  const { cards, summary, loading, fetchSummary, changeCompanyStatus } = useDashboard();
  const [taskFilter, setTaskFilter] = useState("7d")
  const [recordFilter, setRecordFilter] = useState("7d")
  const getStatus = (status) => {
    switch (status) {
      case true: return { color: "success", title: 'Approved' }
      case false: return { color: "danger", title: 'Rejected' }
      default: return { color: "warning", title: 'Pending' }
    }
  }
  const changeStatus = (item) => {
    changeCompanyStatus({ ...item, status: !item.status });
  }

  // constatns
  const labels = ['#', 'Company', 'Industry', 'Subscription', 'Status']

  useEffect(() => {
    fetchSummary(taskFilter, recordFilter)
  }, [taskFilter, recordFilter])
  const data = summary?.companies
    ?.slice(0, 5)
    .map((item, index) => {
      const status = getStatus(item.status);
      return {
        data: item,
        fields: [
          <Link to={`/profile?companyID=${item._id}`} state={item} >
            #{item?._id?.substr(item?._id.length - 5)}
          </Link>,
          <p>{item?.name}</p>,
          <p>{item?.nature?.name}</p>,
          <p>{item?.subscriptionID?.name}</p>,
          // <span className={`badge bg-${status?.color}`}>{status?.title}</span>,
          <div className='form-check form-switch'>
            <input
              className='form-check-input'
              type='checkbox'
              checked={item.status == undefined ? false : item.status}
              onChange={() => changeStatus(item)}
            />
          </div>,
        ].filter(it => it)
      }
    })

  return (
    <Screen loading={loading} flow={[
      { label: 'Dashboard', to: '/' },
      { label: 'Home', to: '/' },
      { label: 'Dashboard', to: '/' }
    ]}>
      <section className="section dashboard">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              {
                cards?.map((card, index) => (
                  <div key={index} className="col-xxl-4 col-md-6">
                    <SummaryCard
                      title={card.title}
                      value={card.value}
                      subtitle={card.subtitle}
                      icon={card.icon}
                      className={card.className}
                      to={card.to}
                    />
                  </div>
                ))
              }
            </div>
            </div>
            {(isAdmin || isCompany) && <>
            <div className={`${taskFilter == '7d' && recordFilter == '7d' ? 'col-lg-6' : 'col-lg-12'} col-md-12`}>
              <LineGraphWithShadow chartData={summary?.tasksCount} filter={taskFilter} setFilter={setTaskFilter} label={'Tasks'} />
            </div>
            <div className={`${recordFilter == '7d' && taskFilter == '7d' ? 'col-lg-6' : 'col-lg-12'} col-md-12`}>
              <LineGraphWithShadow chartData={summary?.recordsCount} filter={recordFilter} setFilter={setRecordFilter} label={'Records'} />
            </div>
            </>}
            <div className="col-lg-12">
              {
                user?.role != 'admin' ? null :
                  <div className="col-12">
                    <Table
                      title={'Recent Registrations'}
                      className={'recent-sales overflow-auto'}
                      labels={labels}
                      data={data}
                    />
                  </div>
              }
            </div>
          {/* </div> */}
        </div>
      </section>
    </Screen>
  )
}
const LineGraphWithShadow = ({ chartData, filter, setFilter, label }) => {

  return (
    <Card>
      <div className="items-center mb-6  d-flex" style={{ justifyContent: 'space-between', padding: '20px 20px' }}>
        <h4 className="text-lg font-semibold text-gray-800">{label}</h4>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="7d">Last 7 Days</option>
          <option value="30d">Last 30 Days</option>
          <option value="1y">Last Year</option>
        </select>
      </div>

      <ResponsiveContainer style={{ paddingRight: '20px' }} width="100%" height={300}>
        <AreaChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Area type="monotone" dataKey={label} stroke="#8884d8" fill="#8884d8" />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default Dashboard